<script>
import rpcjs from 'rpcjs';
const {goto, title} = rpcjs.props;
title.set('Home');
let mainDiv;
const next = () => {
    mainDiv.style.left='-100vw';
    setTimeout(() => {
        goto('/problem');
    }, 600);
};
/**
 * Adds two numbers together.
 * @param {int} e The first number.
 */
function keycheck(e) {
    e.preventDefault();
    if (e.key == 'ArrowRight') {
        next();
    }
}

</script>
<svelte:window on:keyup={keycheck}/>
<section>
    <div class="main-div" bind:this={mainDiv} role="presentation" on:click={next}>
        <div class="background-img">
            <img
                src="../images/header/svg.png"
                alt=""
                width="100%"
                height="100%"
            />
            <div class="text-section">
                <div class="gaming">
                    <p><span>GAMING </span> IS REDEFINING HOW WE</p>
                </div>
                <div class="socialize">
                    <p>SOCIALIZE</p>
                    <p>PLAY</p>
                    <p>WORK</p>
                </div>
                <div class="role">
                    <p>
                        Game-tech will play a pivotal role in shaping the future
                        of <span> everything human.</span>
                    </p>
                    <div class="sign">
                        <img
                            src="../images/header/zigzag31.svg"
                            alt=""
                            width="100%"
                            height="100%"
                        />
                    </div>
                </div>

                <div class="next">
                    <img
                        src="../images/header/Vector.svg"
                        alt=""
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
            <div class="human">
                <img
                    src="../images/header/gradientaicloudwithbrokenpieces1.png"
                    alt="human"
                    class="human"
                />
            </div>
        </div>
    </div>
    <div class="whiteDiv">
    </div>
</section>

<style>
    section{
        position: relative;
    }
    .whiteDiv{
        position: absolute;
        background-color: white;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        top: 0;
    }
    .main-div {
        position: relative;
        z-index: 1;
        transition-duration: 0.6s;
        left: 0;
    }
    .background-img {
        height: 100vh;
        overflow: hidden;
        position: relative;
    }
    .gaming {
        position: absolute;
        top: 29.630vh;
        left: 62.708vw;
    }
    .gaming p {
        font-family: "Montserrat";
        font-weight: 400;
        font-size: 1.563vw;
        color: white;
        margin: 0;
    }
    .gaming p span {
        font-weight: 900;
        color: #ffcc33;
    }
    .socialize {
        width: fit-content;
        height: 3.021vw;
        position: absolute;
        right: 10.2vw;
        top: 34.722vh;
        text-align: left;
    }
    .socialize p {
        font-weight: 800;
        font-size: 4.167vw;
        font-family: "Montserrat";
        color: white;
        margin: 0;
        line-height: 3vw;
        padding-right: 3.438vw;
        position: relative;
        margin-bottom: 1vw;
    }
    .socialize p:nth-child(1)::after {
        content: "";
        width: 54.677vw;
        height: 3.021vw;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.2);
        right: 0vw;
        border-radius: 0.521vw;
    }
    .socialize p:nth-child(2)::after {
        content: "";
        width: 54.677vw;
        height: 3.021vw;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.2);
        right: 12.927vw;
        border-radius: 0.521vw;
    }
    .socialize p:nth-child(3)::after {
        content: "";
        width: 54.677vw;
        height: 3.021vw;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.2);
        right: 9.75vw;
        border-radius: 0.521vw;
    }
    .role {
        position: absolute;
        top: 61.852vh;
        /* bottom: 24.594vh; */
        /* left: 63.229vw; */
        right: 7.500vh;
        text-align: left;
        width: 32.552vw;
    }
    .role p {
        font-size: 1.563vw;
        font-family: "Montserrat";
        color: white;
        font-weight: 400;
        line-height: 1.719vw;
    }
    .role p span {
        color: #ffcc33;
        font-weight: 600;
    }
    .sign {
        height: 2.295vw;
        width: 10.535vw;
        position: absolute;
        right: 0.425vw;
    }
    div.human {
        position: absolute;
        height: 100vh;
        top: 0;
        right: 42.812vw;
        width: 57.188vw;
    }
    img.human {
        object-fit: cover;
        width: 100%;
        height: 100%;
        object-position: right;
    }
    .next {
        position: absolute;
        width: 0.539vw;
        height: 0.693vw;
        top: 93.981vh;
        /* bottom: 4.787vh; */
        right: 2.586vw;
    }
</style>
